export let writeEmailHeaderText = "tgARKd";
export let emailListHeaderText = "Wg7red";
export let readEmailHeaderText = "Kktrf";
export let goToHeaderText = "PoY13c";
export let emailActionsHeaderText = "H3qMCe";
export let newEmailCommand = "JYZMLb";
export let sendEmailCommand = "fRx6Le";
export let replyEmailCommand = "VFM5ce";
export let replyAllEmailCommand = "ulKZCe";
export let forwardEmailCommand = "qw8xtb";
export let saveDraftCommand = "hGFVhd";
export let discardDraftCommand = "uoge3d";
export let goToInboxCommand = "_E9bIc";
export let goToDraftsCommand = "Y2s7$c";
export let goToSentCommand = "c1Y8Rb";
export let searchEmailCommand = "Bk5njb";
export let undoCommand = "JgSE$d";
export let clearAllMessagesCommand = "zRSXJc";
export let homeCommand = "IFOmYb";
export let endCommand = "ayQrIe";
export let copyMailToClipboardCommand = "eePAPd";
export let cutMailToClipboardCommand = "jWe61d";
export let pasteMailFromClipboardCommand = "htZOB";
export let deleteEmailCommand = "CnqeId";
export let openEmailCommand = "jOx25";
export let openEmailInNewWindowCommand = "CHBfnd";
export let closeEmailCommand = "RQICxe";
export let openNextItemCommand = "VIg5zd";
export let openPreviousItemCommand = "FeBOhe";
export let focusNextItemPartCommand = "WFJQXd";
export let focusPreviousItemPartCommand = "uZvFLb";
export let expandCollapseConversationCommand = "tLIeF";
export let expandConversationCommand = "i5RsXd";
export let collapseConversationCommand = "vPWE6d";
export let softDeleteCommand = "arFO3b";
export let newFolderCommand = "pvNo5c";
export let markReadCommand = "gJGdfc";
export let markUnreadCommand = "Dlcgtd";
export let flagEmailCommand = "VYJeSc";
export let archiveCommand = "HSAz1";
export let markJunkCommand = "c_Rkwc";
export let categorize = "fEcPlb";
export let insertHyperlinkCommand = "W13DN";
export let openMessageEditorCommand = "xpt7J";
export let showKeyboardShortcutsCommand = "gQAXod";
export let toggleSelectMessageCommand = "IRBxwe";
export let quickStepCommand = "sG6J2d";
export let zoomInCommand = "xASbVe";
export let zoomOutCommand = "cLgHAb";
export let resetZoomCommand = "n6FBFc";
export let exitMessageEditor = "aXoif";
export let printEmailCommand = "Mbu2J";
export let syncMaiboxCommand = "axjUHc";
export let goToFolderPaneCommand = "kmm2Db";
export let openCopilot = "MQ6IE";
export let findInEmailCommand = "DiKArd";
export let applySpecificCategoryCommand = "Nj5Ls";
export let goToMailTipsCommand = "$2SG1c";
export default {writeEmailHeaderText,emailListHeaderText,readEmailHeaderText,goToHeaderText,emailActionsHeaderText,newEmailCommand,sendEmailCommand,replyEmailCommand,replyAllEmailCommand,forwardEmailCommand,saveDraftCommand,discardDraftCommand,goToInboxCommand,goToDraftsCommand,goToSentCommand,searchEmailCommand,undoCommand,clearAllMessagesCommand,homeCommand,endCommand,copyMailToClipboardCommand,cutMailToClipboardCommand,pasteMailFromClipboardCommand,deleteEmailCommand,openEmailCommand,openEmailInNewWindowCommand,closeEmailCommand,openNextItemCommand,openPreviousItemCommand,focusNextItemPartCommand,focusPreviousItemPartCommand,expandCollapseConversationCommand,expandConversationCommand,collapseConversationCommand,softDeleteCommand,newFolderCommand,markReadCommand,markUnreadCommand,flagEmailCommand,archiveCommand,markJunkCommand,categorize,insertHyperlinkCommand,openMessageEditorCommand,showKeyboardShortcutsCommand,toggleSelectMessageCommand,quickStepCommand,zoomInCommand,zoomOutCommand,resetZoomCommand,exitMessageEditor,printEmailCommand,syncMaiboxCommand,goToFolderPaneCommand,openCopilot,findInEmailCommand,applySpecificCategoryCommand,goToMailTipsCommand};